import {
  createEntityAdapter, createSlice
} from '@reduxjs/toolkit';
import { oauth } from '../utils';

interface Feature {
  feature_id: string;
  feature_name: string;
  feature_description: string;
}

export type CurrentStripeSubscription = {
  price_id: string;
  product_name?: string | null;
  interval: string | null;
  renewal_date: string | null;
} | null;

/**
* The entity adapter
*/
const adapter = createEntityAdapter({
  selectId: (feature: Feature) => feature.feature_id,
});

const slice = createSlice({
  name: 'features',
  initialState: adapter.getInitialState({
      loading: 'idle' as 'idle' | 'pending',
      currentStripeSubscription: null as CurrentStripeSubscription,
  }),
  reducers: {
      loading(state, action) {
          if (state.loading === 'idle') {
              state.loading = 'pending';
          }
      },
      loaded(state, action) {
          if (state.loading === 'pending') {
              state.loading = 'idle';
          }
      },
      received(state, action) {
          if (state.loading === 'pending') {
              adapter.setAll(state, action.payload.features);
              state.currentStripeSubscription = action.payload.currentStripeSubscription ?? null;
              state.loading = 'idle';
          }
      },
  }
});

export const {
  loading,
  loaded,
  received,
} = slice.actions;

const baseUrl = 'feature';

/**
* The actions (thunk)
*/
export const getAll = (
  companyType: string,
  tenantId?: string,
  fetchStripeData = false,
) => async (dispatch, getState) => {
  const state = getState();
  dispatch(loading(state));
  let data = [];
  if (companyType) {
    const params: Record<string, string | boolean> = { company_type: companyType };
    if (tenantId) {
      params.tenant_id = tenantId;
    }
    if (fetchStripeData) {
      params.fetch_stripe_data = true;
    }
    const res = await oauth('GET', baseUrl, params);
    dispatch(received({
      features: res.json.features,
      currentStripeSubscription: res.json.current_stripe_subscription ?? null,
    }));
    data = res.json;
  }
  dispatch(loaded(state));
  return data;
};

/**
* The selectors
*/
export const selectors = adapter.getSelectors();

export default slice.reducer;

